export const localeLanguageTag = (code: string): string => {
  try {
    const locale = new Intl.Locale(code.replace('_', '-')).maximize();

    return locale.region ? `${locale.language}-${locale.region}` : locale.language;
  } catch {
    return code;
  }
};

export const localeOpenGraphTag = (code: string): string =>
  localeLanguageTag(code).replace('-', '_');
